import { render, staticRenderFns } from "./deptList.vue?vue&type=template&id=c615cec4&scoped=true"
import script from "./deptList.vue?vue&type=script&lang=js"
export * from "./deptList.vue?vue&type=script&lang=js"
import style0 from "./deptList.vue?vue&type=style&index=0&id=c615cec4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c615cec4",
  null
  
)

export default component.exports